import api from './axios';

export const authApi = {
  login: (data) => api.post('/auth/login', data),
  verify2FA: (data) => api.post('/auth/verify-2fa', data),
  resend2FA: (data) => api.post('/auth/resend-2fa', data),
  enable2FA: () => api.post('/auth/2fa/enable'),
  disable2FA: (data) => api.post('/auth/2fa/disable', data),
  logout: () => api.post('/auth/logout'),
  refreshToken: (data) => api.post('/auth/refresh', data),
  getMe: () => api.get('/auth/me'),
  changePassword: (data) => api.post('/auth/change-password', data),
  changeEmail: (data) => api.post('/auth/change-email', data)
};

export const panelsApi = {
  list: (params) => api.get('/panels', { params }),
  getById: (id) => api.get(`/panels/${id}`),
  verifyDomain: (domain, cloudflareMode) => api.post('/panels/verify-domain', { domain, cloudflareMode }),
  create: (data) => api.post('/panels', data),
  update: (id, data) => api.put(`/panels/${id}`, data),
  toggle: (id) => api.post(`/panels/${id}/toggle`),
  approve: (id) => api.post(`/panels/${id}/approve`),
  reject: (id) => api.post(`/panels/${id}/reject`),
  retry: (id) => api.post(`/panels/${id}/retry`),
  renew: (id) => api.post(`/panels/${id}/renew`),
  delete: (id) => api.delete(`/panels/${id}`),
  loginAsAdmin: (id, mode) => api.post(`/panels/${id}/login-as-admin`, { mode }),
  getStatistics: (id) => api.get(`/panels/${id}/statistics`),
  getAdminAccounts: (id) => api.get(`/panels/${id}/admins`),
  createAdminAccount: (id, data) => api.post(`/panels/${id}/admins`, data),
  updateAdminAccount: (id, adminId, data) => api.put(`/panels/${id}/admins/${adminId}`, data),
  deleteAdminAccount: (id, adminId) => api.delete(`/panels/${id}/admins/${adminId}`),
  getSettings: (id) => api.get(`/panels/${id}/settings`),
  updateSettings: (id, data) => api.put(`/panels/${id}/settings`, data),
  updateCredentials: (id, data) => api.put(`/panels/${id}/credentials`, data),
  syncStats: () => api.post('/panels/sync-stats')
};

export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats')
};

export const usersApi = {
  list: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`)
};

export const dnsApi = {
  list: (panelId) => api.get(`/panels/${panelId}/dns`),
  create: (panelId, data) => api.post(`/panels/${panelId}/dns`, data),
  delete: (panelId, zoneId, recordId) => api.delete(`/panels/${panelId}/dns/${zoneId}/${recordId}`)
};

export const sslApi = {
  enable: (panelId, data) => api.post(`/panels/${panelId}/ssl/enable`, data),
  disable: (panelId) => api.post(`/panels/${panelId}/ssl/disable`),
  getStatus: (panelId) => api.get(`/panels/${panelId}/ssl/status`)
};

export const servicesApi = {
  restartPhp: (panelId) => api.post(`/panels/${panelId}/services/restart-php`),
  restartNginx: (panelId) => api.post(`/panels/${panelId}/services/restart-nginx`),
  getStatus: (panelId) => api.get(`/panels/${panelId}/services/status`)
};

export const logsApi = {
  getError: (panelId, params) => api.get(`/panels/${panelId}/logs/error`, { params }),
  getAccess: (panelId, params) => api.get(`/panels/${panelId}/logs/access`, { params })
};

export const perfectPaymentApi = {
  list: () => api.get('/perfect-panel/methods'),
  getById: (id) => api.get(`/perfect-panel/methods/${id}`),
  create: (data) => api.post('/perfect-panel/methods', data),
  update: (id, data) => api.put(`/perfect-panel/methods/${id}`, data),
  toggle: (id) => api.post(`/perfect-panel/methods/${id}/toggle`),
  delete: (id) => api.delete(`/perfect-panel/methods/${id}`),
  regenerateStatic: () => api.post('/perfect-panel/regenerate-static')
};

export const godeskApi = {
  getTickets: () => api.get('/godesk/tickets'),
  getTicketReplies: (id) => api.get(`/godesk/tickets/${id}/replies`),
  replyToTicket: (id, data) => api.post(`/godesk/tickets/${id}/replies`, data),
  closeTicket: (id) => api.post(`/godesk/tickets/${id}/close`),
  getNotifications: () => api.get('/godesk/notifications'),
  sendNotification: (data) => api.post('/godesk/notifications', data),
  updateNotification: (id, data) => api.put(`/godesk/notifications/${id}`, data),
  deleteNotification: (id) => api.delete(`/godesk/notifications/${id}`)
};

// Popups pushed to external panels (not our child panels) via a footer snippet.
export const broadcastApi = {
  info: () => api.get('/broadcasts/info'),
  listPanels: () => api.get('/broadcasts/embeds'),
  createPanel: (data) => api.post('/broadcasts/embeds', data),
  updatePanel: (id, data) => api.put(`/broadcasts/embeds/${id}`, data),
  deletePanel: (id) => api.delete(`/broadcasts/embeds/${id}`),
  rotatePanelKey: (id) => api.post(`/broadcasts/embeds/${id}/rotate-key`),
  list: () => api.get('/broadcasts'),
  create: (data) => api.post('/broadcasts', data),
  update: (id, data) => api.put(`/broadcasts/${id}`, data),
  delete: (id) => api.delete(`/broadcasts/${id}`),
  stats: (id) => api.get(`/broadcasts/${id}/stats`)
};

// Drop Checker: scans one service's orders on a third-party PerfectPanel and
// compares each order's live count against what it delivered.
export const dropCheckerApi = {
  getSettings: () => api.get('/drop-checker/settings'),
  updateSettings: (data) => api.put('/drop-checker/settings', data),
  scanOrders: (data) => api.post('/drop-checker/orders', data),
  liveCounts: (data) => api.post('/drop-checker/live-counts', data),
  testPanel: () => api.post('/drop-checker/test-panel'),
  testScraper: (data) => api.post('/drop-checker/test-scraper', data),
  startBackground: (data) => api.post('/drop-checker/jobs', data),
  listJobs: () => api.get('/drop-checker/jobs'),
  getJob: (id) => api.get(`/drop-checker/jobs/${id}`),
  stopJob: (id) => api.post(`/drop-checker/jobs/${id}/stop`)
};
